import React, {Fragment} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faFilter, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const ControlBtns = ({
  show,
  setShow,
  showFilters,
  setShowFilters,
  view,
  history
}) => {

   const handleFilters = () => {
      setShowFilters(!showFilters);
      setShow(false);
   };

   const handleSearch = () => {
      setShow(!show);
      setShowFilters(false);
   };

  return (
    <Fragment>

      {
          window.innerWidth<768 ?
          <div className="row mt-15 border-bottom">
            { view==="search" ?
                <div className={"col-6 np-sides-all"}>
                  <button
                    className={"btn btn-outline-secondary"}
                    onClick={() => handleFilters()}
                  ><FontAwesomeIcon icon={faFilter} />   Filtros
                  </button>
                </div>
              :
                null
            }

            { view==="details" ?
                <div className={"col-6 np-sides-all"}>
                  <button
                    className={"btn btn-outline-secondary"}
                    onClick={() => history.goBack()}
                  ><FontAwesomeIcon icon={faArrowLeft} /> Regresar
                  </button>
                </div>
              :
                null
            }

            <div className={"col-6 np-sides-all"} style={{ textAlign: 'right' }}>
              <button
                className={"btn btn-outline-secondary"}
                onClick={() => handleSearch()}
              ><FontAwesomeIcon icon={faSearch} />   Buscar
              </button>
            </div>
          </div>
          :
          null
      }

    </Fragment>
  )
};

export default ControlBtns;
